var map = {
	"./boots/overall/red.jpg": "832c",
	"./gloves/overall/red.jpg": "b2f5",
	"./jackets/back/red.jpg": "76e0",
	"./jackets/chest/red.jpg": "d508",
	"./jackets/elbow/red.jpg": "74db",
	"./jackets/shoulder/red.jpg": "a7e3",
	"./pants/hip/red.jpg": "8936",
	"./pants/knee/red.jpg": "8a9a",
	"./pants/tailbone/red.jpg": "a5f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bb8";